import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Patrimonio } from 'src/app/admihair/api/dto/patrimonio';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PatrimonioService } from 'src/app/admihair/service/patrimonio.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-patrimonio-inserir',
  templateUrl: './patrimonio-inserir.component.html',
  styleUrls: ['./patrimonio-inserir.component.scss']
})
export class PatrimonioInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  messages: Message[] = [];
  permissaoInserir: boolean = false;
  progressoRequisicao: boolean = false;

  patrimonio: Patrimonio = {
    descricao: '',
    grupo: '',
    marcaModelo: '',
    numeroSerie: '',
    tombo: '',
    disposicaoDoBem: '',
    observacoes: '',
    situacao: '',
    valorAquisicaoAvaliacao: 0,
    valorResidualDescarte: 0,
    percentualResidualAnual: 0,
    vidaUtilMeses: 0,
    planoContaEmpresa: 0,
  }

  situcoesPatrimonio: SelectItem[] = [
    {label: 'ATIVO', value: 'ATIVO'},
    {label: 'INATIVO', value: 'INATIVO'},
    {label: 'BAIXADO', value: 'BAIXADO'},
    {label: 'EM ESTOQUE', value: 'EM_ESTOQUE'},
    {label: 'EMPRESTADO', value: 'EMPRESTADO'}
  ];

  constructor(private patrimonioService: PatrimonioService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService
  ) {

  }

  ngOnInit(): void {
    this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_PATRIMONIO');
  }

  salvar() {
    this.progressoRequisicao = true;
    this.patrimonio.empresaId = this.utilStorageService.getEmpresa().id;
    this.patrimonioService.salvar(this.patrimonio).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
      }
    })

  }

  limparFormulario() {
    this.form?.reset();
  }

}
